import {useQuery} from 'react-query';
import getStoreInputs from './getStoreInputs';

const useGetStoreInputs = (storeGuid?: string, input_group?: number) => {
  const {data, isLoading, refetch} = useQuery({
    queryKey: ['get-store-input', storeGuid, input_group],
    queryFn: () => getStoreInputs(storeGuid, input_group),
    enabled: Boolean(storeGuid),
  });

  return {data, isLoading, refetch};
};

export default useGetStoreInputs;
